import { ErrorMessageContents } from '../../helpers/hub'
import { UserPreferences } from './type'

export const fetchUserPreferences = () =>
  ({ type: 'userPreferences.fetchUserPreferences' } as const)
type FetchUserPreferencesAction = ReturnType<typeof fetchUserPreferences>

export const fetchUserPreferencesFailure = (error: ErrorMessageContents) =>
  ({
    type: 'userPreferences.fetchUserPreferencesFailure',
    payload: error,
    error: true
  } as const)
type FetchUserPreferencesFailureAction = ReturnType<
  typeof fetchUserPreferencesFailure
>

export const fetchUserPreferencesSuccess = (userPreferences: UserPreferences) =>
  ({
    type: 'userPreferences.fetchUserPreferencesSuccess',
    payload: userPreferences
  } as const)
type FetchUserPreferencesSuccessAction = ReturnType<
  typeof fetchUserPreferencesSuccess
>

export const setUserPreferences = (userPreferences: UserPreferences) =>
  ({
    type: 'userPreferences.setUserPreferences',
    payload: userPreferences
  } as const)
export type SetUserPreferencesAction = ReturnType<typeof setUserPreferences>

export const setUserPreferencesFailure = (error: ErrorMessageContents) =>
  ({
    type: 'userPreferences.setUserPreferencesFailure',
    payload: error,
    error: true
  } as const)
type SetUserPreferencesFailureAction = ReturnType<
  typeof setUserPreferencesFailure
>

export const setUserPreferencesSuccess = (
  userPreferences: UserPreferences,
  transactionId?: number
) =>
  ({
    type: 'userPreferences.setUserPreferencesSuccess',
    payload: { userPreferences, transactionId }
  } as const)
type SetUserPreferencesSuccessAction = ReturnType<
  typeof setUserPreferencesSuccess
>

export type UserPreferencesAction =
  | FetchUserPreferencesAction
  | FetchUserPreferencesSuccessAction
  | FetchUserPreferencesFailureAction
  | SetUserPreferencesAction
  | SetUserPreferencesFailureAction
  | SetUserPreferencesSuccessAction
